import React from 'react';
import { Button, Form, FormGroup, Input, Label, FormFeedback } from 'reactstrap';
import { addGroupFormValidation } from 'form-validations';
import {connect} from 'react-redux';
import {UsersGroupsAction} from 'redux/actions';
import PropTypes from 'prop-types';

const AddGroupForm = ({createNewGroup,groupAdded,groupId, groupName}) => {

    let [values, setValues] = React.useState({});
    let [errors, setErrors] = React.useState({});
    let [isSubmitted, setIsSubmitted] = React.useState(false);
    let [isValid, setIsValid] = React.useState(true);

    React.useEffect(() => {
        const validationErrors = addGroupFormValidation(values);
        isValid = Object.keys(validationErrors).length === 0;
        setIsValid(isValid);
        setErrors(validationErrors);
    }, [values]);

    React.useEffect(() => {
        setValues({
            name: groupName,id: groupId
        })
    }, [groupName,groupId]);

    const handleChange = (event) => {
        setValues({
          ...values, [event.target.name]: event.target.value
        })
    };

    const handleSubmit = () =>{
        setIsSubmitted(true);
        if(isValid){
            createNewGroup(values);
        }
    }

    React.useEffect(()=>{
        setIsSubmitted(false);
    },[groupAdded]);

    return (
        <div>
            <Form>
                <FormGroup>
                    <Label for={'name'}>{'Group Name'}</Label>
                    <Input
                        type="text"
                        name="name"
                        id="name"
                        onChange={handleChange}
                        autoComplete={'off'}
                        value={(values && values.name)?values.name:''}
                    />
                    {(isSubmitted && errors.name && !values.name) && <FormFeedback >{errors.name} </FormFeedback>}
                </FormGroup>
                <Button
                  size="sm"
                  color="primary"
                  className="border-0"
                  block
                  onClick={handleSubmit}
                  >
                  {groupId?'Edit Group':'Add Group'}
                </Button>
            </Form>
        </div>
    );
};

const mapStateToProps = (state) =>({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    groupAdded: (state.groups && state.groups.groupAdded) ? state.groups.groupAdded : {},
})

const mapDispatchToProps = (dispatch) =>({
    createNewGroup: (payload)=>dispatch(UsersGroupsAction.addUserGroup(payload))
})

AddGroupForm.propTypes = {
    createNewGroup:PropTypes.func,
    isLoading:PropTypes.bool,
}

export default connect(mapStateToProps,mapDispatchToProps)(AddGroupForm);